// extracted by mini-css-extract-plugin
export default {"containerChapter":"Chapter_containerChapter__h3OX9","infoChapter":"Chapter_infoChapter__mVKnd","infoEpisode":"Chapter_infoEpisode__rN6Of"};